import {z} from 'zod';
import {baseCardSchema} from './baseSchemas';
import {NodeType} from 'common/src/modules/nodes/nodes.types';

const distributionNodeOutputSchema = z.object({
  name: z.string().describe('The name of the output'),
});

export const distributionCardSchema = baseCardSchema.extend({
  type: z.literal(NodeType.DISTRIBUTION),
  outputs: z.array(distributionNodeOutputSchema),
});

